<span class="multiple-link" *ngIf="params.value == 'Multiple'"
    (click)="onLinkClicked()">
    {{ "chargeback.multipleLabel" | translate }}
</span>
<span *ngIf="params.value != 'Multiple'">
    {{params.value}}
</span>

<ng-container *ngIf="showModal">
    <download-customer-list [visibleCustModal]="showModal" [searchObj]="multipleCustomerRequest" 
    [moduleName]="moduleName" (closedCustModal)="closedCustModal($event)">
    </download-customer-list>
</ng-container>